<template>
  <NoStuffPlaceholder
    :display="!settings.designer"
    heading="POS.SHOP_SETTINGS.STARTPAGE.CYO_INTRO.EDITOR_DISABLED.HEADING"
    sub-heading="POS.SHOP_SETTINGS.STARTPAGE.CYO_INTRO.EDITOR_DISABLED.SUBHEADING"
    cta-icon="shop"
    cta-text="POS.SHOP_SETTINGS.STARTPAGE.CYO_INTRO.EDITOR_DISABLED.LINK"
    cta-target="shop-area.pages.designer"
  />
</template>

<script>
import { SettingsData } from 'src/app/partnerarea/pos/shop/shopSavable/SettingsData';
import NoStuffPlaceholder from 'src/app/partnerarea/pos/shop/common/NoStuffPlaceholder.vue';

export default {
  name: 'CYONoDesignerPlaceholder',
  components: {
    NoStuffPlaceholder,
  },
  mixins: [SettingsData],
};
</script>
